export class FleetUser {
    userId?: string;
    fleetKind?: string;
    isEnabled?: boolean;
}